<template>
  <div>
    <form action @submit.stop="createPhoto">
      <upload-to-firebase :meta="meta" @uploaded="uploaded" :eid="eid"/>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          id="validationCustom01"
          placeholder="Enter a title"
          value
          v-model="photo.title"
          required
        >
        <div class="valid-feedback">Looks good!</div>
      </div>

      <div class="form-group">
        <textarea
          class="form-control"
          id="photo-description"
          rows="3"
          v-model="photo.description"
          placeholder="Enter a description"
        ></textarea>
      </div>
      <!--
  <div class="form-group">

      <input type="text" class="form-control" id="validationCustom03" placeholder="Location" value="" v-model="photo.location">
      <div class="valid-feedback">
        Looks good!
      </div>
    </div>
      -->
      <div class="form-group">
        <select class="form-control" required v-model="photo.year">
          <option value="null" disabled>-- Please select a year --</option>
          <option v-for="year in years" :key="year">{{ year }}</option>
        </select>
        <div class="valid-feedback">Looks good!</div>
      </div>

      <div>
        <input type="submit" class="btn btn-primary" :disabled="disabled == 1 ? true : false">
        <button type="button" class="btn btn-outline-primary ml-1" @click="cancel()">Cancel</button>
      </div>
    </form>
    <br>
  </div>
</template>

<script>
import UploadToFirebase from '@/components/upload/UploadToFirebase.vue'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { UploadToFirebase },
  data() {
    const today = new Date()
    const thisYear = today.getFullYear()
    const goBackTil = thisYear == 2018 ? thisYear - 4 : thisYear - 5
    const years = []
    for (let y = thisYear; y > goBackTil; y--) {
      years.push(y)
    }
    return {
      photo: this.newObject(),
      years,
      disabled: 1
    }
  },
  props: ['meta', 'eid'],
  computed: {
    ...mapState({
      photos: state => state.photo.photos,
      entry: state => state.entry.entry
    }),
    ...mapGetters({
      photoCount: 'photo/photoCount'
    })
  },
  methods: {
    createPhoto(e) {
      e.preventDefault()
      const photoOb = this.photo
      //const photoOb = this.photo
      // console.log('PhotoCount: ' + this.photoCount)
      this.$store
        .dispatch('photo/createPhoto', photoOb)
        .then(() => {
          return (this.photo = this.entryObject())
        })
        .catch(() => {})
      return this.$emit('cancel')
    },
    newObject() {
      const pid = +new Date()
      return {
        order: this.photoCount + 1,
        eid: Number(this.eid),
        pid: pid,
        fileName: '',
        folderName: '',
        filePath: '',
        width: this.getMeta(this.meta.width),
        height: this.getMeta(this.meta.height),
        title: '', // removed: this.sanatisedFileName(this.meta.file.name)
        description: '',
        // location: '',
        year: '',
        flag: true
      }
    },
    getMeta(value) {
      return value
    },
    sanatisedFileName(value) {
      var desired = value.replace(/\.[^/.]+$/, '')
      var short = desired.replace(/[^\w\s]/gi, '')
      return short
    },
    cancel() {
      this.$emit('cancel')
    },
    uploaded(upload) {
      // console.log('In the uploaded function:' + JSON.stringify(upload))
      this.photo.filePath = upload.path
      this.photo.fileName = upload.fileName
      this.photo.folderName = upload.folderName
      this.disabled = 0
      this.photo.order = this.photoCount + 1
    }
  },
  mounted() {}
}
</script>

<style scoped>
form {
  padding-top: 15px;
}
</style>
